import { useCallback } from 'react';

import { find, propEq } from 'ramda';

const useSimpleValueSelect = ({ onChange: originOnChange, value: originValue, options }) => {
  const onChange = useCallback((option) => originOnChange(option?.value ?? null), [originOnChange]);
  const value = options && (find(propEq(originValue, 'value'), options) || null);

  return [value, onChange];
};

export default useSimpleValueSelect;
